'use strict';
module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};



//////////////////
// WEBPACK FOOTER
// ./~/strict-uri-encode/index.js
// module id = 1584
// module chunks = 0